import { css } from '@linaria/core';
export const ExpiredOverlay = {
    base: css `
		position: absolute;
		z-index: 3;

		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;

		box-sizing: border-box;
		width: 100%;
		height: 100%;
		padding: 10%;

		text-align: center;

		background: radial-gradient(
			ellipse at center,
			rgba(var(--global-background), 0.8) 0%,
			rgba(var(--global-background), 0.4) 100%
		);
	`,
};
